/**
 * @module app.bdc.reports.checklistCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function ChecklistCtrl($scope, $rootScope, marketService) {
        var self = {};
        self.order = $rootScope.order;
        self.user = $rootScope.user;

        self.marketService = marketService;

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Get installation date and if there is none check for an installation date for laddition offer
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation() {
            var date = self.order.dateInstallation
                ? self.order.dateInstallation
                : self.order.laddition.dateInstallation
                    ? self.order.laddition.dateInstallation
                    : null;
            return moment(date, 'YYYY-MM-DD').format('MMMM YYYY');
        };

        /**
         * Is NAP order ?
         * @return {Boolean}
         */
        self.isNAP = function isNAP() {
            return self.order.orderType.code === 'NAP';
        };

        /**
         * Is FLORAJET order ?
         * @return {Boolean}
         */
        self.isFLORAJET = function isFLORAJET() {
            return self.order.orderType.code === 'FLORAJET';
        };

        /* Markets */
        self.isBoulangerieMarket = marketService.isBoulangerieMarket(self.order);
        self.isTabacPresseMarket = marketService.isTabacPresseMarket(self.order);
        self.isLadditionMarket = marketService.isLadditionMarket(self.order);
        self.isFleuristeMarket = marketService.isFleuristeMarket(self.order);
        self.isAutreMarket = marketService.isAutreMarket(self.order);

        /* Show / hide lines in check-list */
        self.showLineBalancePointOfSale = function showLineBalancePointOfSale() {
            if (
                self.order.contract.scenarioType.code === 'PERIPHERIQUE' ||
                self.order.contract.scenarioType.code === 'EXTENSION'
            ) {
                return false;
            }
            if (self.isLadditionMarket) {
                return false;
            }
            if (self.order.contract.contractType.code !== 'ACHAT') {
                return true;
            }
            if (self.isNAP() && self.order.contract.scenarioType.code !== 'CONQUETE') {
                return true;
            }
            return false;
        };
        self.showLineKbisRcs = function showLineKbisRcs() {
            if (self.order.contract.scenarioType.code === 'PERIPHERIQUE') {
                return false;
            }
            if (self.isLadditionMarket) {
                return false;
            }
            if (!self.isNAP() && self.order.contract.contractType.code !== 'ACHAT') {
                return true;
            }
            if (self.isNAP() && self.order.contract.scenarioType.code === 'CONQUETE') {
                return true;
            }
            return false;
        };
        self.showLineEquipmentConservation = function showLineEquipmentConservation() {
            if (self.isNAP()) {
                return false;
            }
            if (self.isFLORAJET() && self.order.offer.code == 'webTill') {
                return false;
            }
            if (
                self.order.contract.contractType.code === 'ACHAT' &&
                self.order.contract.scenarioType.code === 'CONQUETE'
            ) {
                return false;
            }
            return true;
        };
        self.showLineWarrantSepaSrdMp = function showLineWarrantSepaSrdMp() {
            if (self.order.contract.scenarioType.code === 'PERIPHERIQUE') {
                return false;
            }
            if (self.isLadditionMarket) {
                return false;
            }
            if (self.isFLORAJET() && self.order.offer.code === 'webTill') {
                return false;
            }
            return true;
        };

        return self;
    }

    ChecklistCtrl.$inject = ['$scope', '$rootScope', 'marketService'];

    angular.module('app.bdc.reports.checklistCtrl', []).controller('ChecklistCtrl', ChecklistCtrl);
});
